var map = {
	"./chat-icon-bottom-nav-mobile-active.webp": 2725,
	"./chat-icon-bottom-nav-mobile.webp": 2726,
	"./home-icon-bottom-nav-mobile-active.webp": 2727,
	"./home-icon-bottom-nav-mobile-active_b.webp": 2728,
	"./home-icon-bottom-nav-mobile.webp": 2729,
	"./home-icon-bottom-nav-mobile_b.webp": 2730,
	"./me-icon-bottom-nav-mobile-active.webp": 2731,
	"./me-icon-bottom-nav-mobile.webp": 2732,
	"./promo-icon-bottom-nav-mobile-active.webp": 2733,
	"./promo-icon-bottom-nav-mobile.webp": 2734,
	"./sponsor-icon-bottom-nav-mobile-active.webp": 2735,
	"./sponsor-icon-bottom-nav-mobile.webp": 2736,
	"./stream-icon-bottom-nav-mobile-active.webp": 2737,
	"./stream-icon-bottom-nav-mobile.webp": 2738
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2724;